import { useEffect } from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import DateSocialShareBody from 'govbr.frontend.policy/components/Blocks/DateShare/DateSocialShareBody';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { Container as SemanticContainer } from 'semantic-ui-react';

const LinkView = ({ token, content }) => {
  const history = useHistory();
  useEffect(() => {
    if (!token) {
      const { remoteUrl } = content;
      // URLs de arquivo não são rotas do Volto; navegar via router busca conteúdo e quebra os reducers
      const isFileUrl =
        remoteUrl?.includes('@@download') ||
        remoteUrl?.includes('@@display-file');
      if (isInternalURL(remoteUrl) && !isFileUrl) {
        history.replace(flattenToAppURL(remoteUrl));
      } else if (isInternalURL(remoteUrl) && !__SERVER__) {
        // createHref preserva o prefix path (ex.: /inst)
        window.location.replace(
          history.createHref({ pathname: flattenToAppURL(remoteUrl) }),
        );
      } else if (!__SERVER__) {
        window.location.href = flattenToAppURL(remoteUrl);
      }
    }
  }, [content, history, token]);
  if (__SERVER__ && !token && content.remoteUrl) {
    return <Redirect to={content.remoteUrl} />;
  }
  const { title, description, remoteUrl } = content;
  const { openExternalLinkInNewTab } = config.settings;
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;

  return (
    <Container id="page-document" className="mb-3xh">
      <h1 className="documentFirstHeading">{title}</h1>
      {content.description && (
        <p className="documentDescription">{description}</p>
      )}
      <DateSocialShareBody properties={content} />
      {remoteUrl && (
        <p>
          <FormattedMessage
            id="The link address is:"
            defaultMessage="The link address is:"
          />{' '}
          <UniversalLink
            href={remoteUrl}
            openLinkInNewTab={
              openExternalLinkInNewTab && !isInternalURL(remoteUrl)
            }
          >
            {flattenToAppURL(remoteUrl)}
          </UniversalLink>
        </p>
      )}
    </Container>
  );
};

LinkView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    remoteUrl: PropTypes.string,
  }),
  token: PropTypes.string,
};

LinkView.defaultProps = {
  content: null,
  token: null,
};

export default LinkView;
